import {Material, VECTOR3} from '../../index.js';

/**
 * Creates Hypercube.js color materials.
 * @example
 * const materialcolor = new MaterialColor(name, color);
 */
class MaterialColor extends Material {

    /**
     * Stores the color.
     * @type {vector3}
     * @protected
     */
    $color;

    /**
     * Stores the type.
     * @type {string}
     * @protected
     */
    $type = 'material.color';

    /**
     * Gets the color.
     * @type {vector3}
     * @public
     * @readonly
     */
    get color() {

        return this.$color;
    };

    // @TODO : replace {any} for $parameters

    /**
     * Creates a new Hypercube.js color material.
     * @param {string} $name The name of the material.
     * @param {any} [$parameters] The parameters of the material.
     */
    constructor($name, $parameters) {

        super($name, $parameters);

        this.$color = VECTOR3.clone($parameters.color);
    }
}

export {

    MaterialColor
};

export default MaterialColor;
